/**
 * useToast — Hook simple para feedback transitorio (save success / error).
 * Uso:
 *   const { toast, ToastContainer } = useToast();
 *   toast.success('Guardado');  toast.error('Falló');
 *
 *   return (<>...<ToastContainer /></>);
 */
import React, { useState, useCallback } from 'react';
import { Snackbar, Alert } from '@mui/material';

export default function useToast() {
  const [state, setState] = useState({ open: false, message: '', severity: 'success' });

  const show = useCallback((message, severity = 'success') => {
    setState({ open: true, message, severity });
  }, []);

  const toast = {
    success: (m) => show(m, 'success'),
    error:   (m) => show(m, 'error'),
    info:    (m) => show(m, 'info'),
    warning: (m) => show(m, 'warning'),
  };

  const ToastContainer = () => (
    <Snackbar
      open={state.open}
      autoHideDuration={3500}
      onClose={() => setState(s => ({ ...s, open: false }))}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert severity={state.severity} variant="filled" elevation={6}
        onClose={() => setState(s => ({ ...s, open: false }))}
        sx={{ fontWeight: 600, fontSize: 13 }}>
        {state.message}
      </Alert>
    </Snackbar>
  );

  return { toast, ToastContainer };
}
